import { HOME_URL, DIRECTORIES_URL, SOURCE_URL, SOURCE_CREATE_URL } from 'components/Router/consts';

// Routes
export const NAME_YOUR_DATA_URL = '/initiate-your-data';
export const CHOOSE_SOURCE_TYPE_URL = '/choose-source-type';
export const AUTHORIZE_DATA_ACCESS_URL = '/authorize-data-access';
export const CHOOSE_SYNC_GROUPS_URL = '/choose-sync-groups';
export const UPLOAD_CSV_URL = '/upload-csv';
export const MAP_ATTRIBUTES_URL = '/map-attributes';
export const DATA_SETTINGS_URL = '/data-settings';
export const SOURCE_WIZARD_BASE_URL = `${HOME_URL}${DIRECTORIES_URL}${SOURCE_CREATE_URL}`;
export const SOURCE_WIZARD_BASE_URL_W_DIRECTORY_ID = `${HOME_URL}${DIRECTORIES_URL}/:id${SOURCE_CREATE_URL}`;
export const SOURCE_WIZARD_BASE_URL_W_DIRECTORY_SOURCE_IDS = `${HOME_URL}${DIRECTORIES_URL}/:id${SOURCE_URL}/:id${SOURCE_CREATE_URL}`;
export const CSV_WIZARD_URL = `/csv-wizard`;
export const CSV_WIZARD_UPLOAD_URL = '/csv-upload';
export const CSV_WIZARD_MAPPING_URL = '/mapping';
export const MAPPINGS_TAB = '/mappings';
export const DIRECTORY_APP_USERS = '/search/user';

// Source types
export const CSV_SOURCE_TYPE_KEY = 'csv';
export const AZURE_SOURCE_TYPE_KEY = 'azure-active-directory';
export const GOOGLE_SOURCE_TYPE_KEY = 'google-directory';
export const LDAP_SOURCE_TYPE_KEY = 'ldap';
export const UKG_SOURCE_TYPE_KEY = 'ukg';
export const OKTA_SOURCE_TYPE_KEY = 'okta';
export const DEMO_DATA_SOURCE_TYPE_KEY = 'demo-data';

// Mapping attributes
export const CLIENT_PRIMARY_KEY = 'clientPrimaryKey';
export const REQUIRED_PROFILE_ATTR_KEYS = ['email', 'firstName', 'lastName'];
// Mapping type keys
export const PRIMARY_MAPPING_TYPE_KEY = 'primary';
export const ORG_MAPPING_TYPE_KEY = 'logistical';
export const PROFILE_ATTR_MAPPING_TYPE_KEY = 'data';
export const HIERARCHY_MAPPING_KEY = 'hierarchy';
// Org mapping
export const ORG_TEAM_LEADER_MAPPING_REF_KEY = 'tlRef';
export const ORG_TEAM_LEADER_MAPPING_MATCH_KEY = 'tlMatch';
export const TL_REF_MAPPING_INDEX = 1;
export const TL_MATCH_MAPPING_INDEX = 0;
export const DEFAULT_EMPTY_ORG_MAPPINGS = [
  {
    source: '',
    type: ORG_MAPPING_TYPE_KEY,
    destination: ORG_TEAM_LEADER_MAPPING_MATCH_KEY,
    isRequired: false,
    isUnique: false,
  },
  {
    source: '',
    type: ORG_MAPPING_TYPE_KEY,
    destination: ORG_TEAM_LEADER_MAPPING_REF_KEY,
    isRequired: false,
    isUnique: false,
  },
];
